import Component from "components/Component";
import Options from "components/common/Options";
import * as labels from "config.labels";
import { useDispatch, useSelector } from "react-redux";
import * as staticDataHooks from "store/hooks/staticDataHooks";
import * as rateChangeSlice from "store/rateChange";

const componentDefns = [
  {
    key: "structure",
    name: "Structure",
    labelKey: labels.RATE_CHANGE_COMPONENT_SELECTOR_STRUCTURE,
  },
  {
    key: "commission",
    name: "Commission",
    labelKey: labels.RATE_CHANGE_COMPONENT_SELECTOR_COMMISSION,
  },
  {
    key: "exposure",
    name: "Exposure",
    labelKey: labels.RATE_CHANGE_COMPONENT_SELECTOR_EXPOSURE,
  },
  {
    key: "uwJudgment",
    name: "UW Judgment",
    labelKey: labels.RATE_CHANGE_COMPONENT_SELECTOR_UW_JUDGMENT,
  },
  {
    key: "inflation",
    name: "Inflation",
    labelKey: labels.RATE_CHANGE_COMPONENT_SELECTOR_INFLATION,
  },
];

const RebaseSelector = () => {
  const dispatch = useDispatch();
  const translateLabel = staticDataHooks.useTranslator("uiLabels");
  const activeLayerRateChange = useSelector(
    rateChangeSlice.selectActiveLayerRateChange
  );
  const options = componentDefns
    .filter(({ key }) => !activeLayerRateChange?.componentDisabled?.[key])
    .map((defn) => {
      return {
        id: defn.key,
        label: defn.labelKey
          ? translateLabel(defn.labelKey, { default: defn.name })
          : defn.name,
        selected: activeLayerRateChange?.rebaseAfter?.[defn.key],
      };
    });

  return (
    <Component
      title={translateLabel(labels.RATE_CHANGE_REBASE_SELECTOR_TITLE, {
        default: "Rebase After",
      })}
      subtitle={translateLabel(labels.RATE_CHANGE_REBASE_SELECTOR_SUBTITLE, {
        default:
          "Select after which components to rebase in the Rate Change calc.",
      })}
    >
      <Options
        items={options}
        onClick={({ id, selected }) =>
          dispatch(
            rateChangeSlice.updateLayerProperties({
              rebaseAfter: {
                ...activeLayerRateChange?.rebaseAfter,
                [id]: !selected,
              },
            })
          )
        }
      />
    </Component>
  );
};

export default RebaseSelector;
